import { Host, h } from "@stencil/core";
export class ChSelectItem {
    constructor() {
        this.height = undefined;
        this.leftIconSrc = undefined;
        this.rightIconSrc = undefined;
        this.selected = undefined;
        this.disabled = undefined;
        this.autoColor = true;
        this.value = undefined;
    }
    /**
     * Emits the item id
     */
    itemClicked;
    el;
    selectOption;
    componentDidRender() {
        if (this.el.hasAttribute("disabled")) {
            this.selectOption.setAttribute("disabled", "");
        }
        if (this.el.hasAttribute("selected")) {
            this.selectOption.classList.add("option-selected");
            const selectedOptionText = this.el.parentElement.shadowRoot.querySelector("span.text");
            selectedOptionText.innerHTML = this.el.innerHTML;
        }
    }
    optionClickedHandler(event) {
        const targetOption = event.el.value;
        if (!event.disabled) {
            this.setActiveOption(targetOption);
            this.itemClicked.emit({ "option-value": targetOption });
        }
    }
    setActiveOption(targetItem) {
        const parent = this.el.parentElement;
        const selectItems = parent.children;
        let optionText = "";
        for (let i = 0; i < selectItems.length; i++) {
            const item = selectItems[i].shadowRoot.lastChild;
            // remove old item selected class
            if (item.classList.contains("option-selected")) {
                item.classList.remove("option-selected");
            }
            selectItems[i].removeAttribute("aria-selected");
            // remove pre-selection attribute
            selectItems[i].removeAttribute("selected");
            // set active item class
            if (selectItems[i].value === targetItem.trim()) {
                item.classList.add("option-selected");
                selectItems[i].setAttribute("aria-selected", "true");
                optionText = selectItems[i].innerHTML;
            }
        }
        // update selected option text in select
        const selectedOptionText = this.el.parentElement.shadowRoot.querySelector("span.text");
        selectedOptionText.innerHTML = optionText;
    }
    resolveLeftIcon() {
        if (this.leftIconSrc !== undefined) {
            return this.leftIconSrc;
        }
        else {
            return "";
        }
    }
    resolveRightIcon() {
        if (this.rightIconSrc !== undefined) {
            return this.rightIconSrc;
        }
        else {
            return "";
        }
    }
    render() {
        return (h(Host, { class: "option", role: "option", value: this.value, onClick: () => this.optionClickedHandler(this) }, h("div", { class: "option", exportparts: "option-text: select-option", ref: el => (this.selectOption = el), style: { height: this.height } }, h("div", { class: "left-container" }, this.leftIconSrc && (h("span", { class: "icon left-icon" }, h("ch-icon", { src: this.resolveLeftIcon(), style: {
                "--icon-size": "20px",
                "--icon-color": `var(--first-list-icon-color)`
            }, "auto-color": this.autoColor }))), h("span", { class: "text", part: "option-text" }, h("slot", null))), this.rightIconSrc && (h("span", { class: "icon right-icon" }, h("ch-icon", { src: this.resolveRightIcon(), style: {
                "--icon-size": "20px",
                "--icon-color": `var(--first-list-icon-color)`
            }, "auto-color": this.autoColor }))))));
    }
    static get is() { return "ch-select-option"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-select-option.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-select-option.css"]
        };
    }
    static get properties() {
        return {
            "height": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "height",
                "reflect": false
            },
            "leftIconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set the left side icon"
                },
                "attribute": "left-icon-src",
                "reflect": false
            },
            "rightIconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set the right side icon"
                },
                "attribute": "right-icon-src",
                "reflect": false
            },
            "selected": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determines the selected option"
                },
                "attribute": "selected",
                "reflect": true
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determines if the option is disabled"
                },
                "attribute": "disabled",
                "reflect": true
            },
            "autoColor": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "true",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If enabled, the option icons will display its inherent/natural color"
                },
                "attribute": "auto-color",
                "reflect": true,
                "defaultValue": "true"
            },
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The select option's value"
                },
                "attribute": "value",
                "reflect": true
            }
        };
    }
    static get events() {
        return [{
                "method": "itemClicked",
                "name": "itemClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emits the item id"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=ch-select-option.js.map
